import React from 'react';
import { Layout, Row, Col, Space, Divider, Tooltip } from 'antd';
import { 
  CustomerServiceOutlined, 
  MessageOutlined, 
  QqOutlined, 
  GithubOutlined,
  HeartOutlined
} from '@ant-design/icons';
import './index.css';

const { Footer } = Layout;

const FooterItem = () => {
  const currentYear = new Date().getFullYear();

  const handleServiceClick = () => {
    window.open('/service', '_blank');
  };

  const handleCommentClick = () => {
    window.open('/message', '_blank');
  };

  const handleQQClick = () => {
    window.open('https://wpa.qq.com/msgrd?v=3&uin=123456789&site=qq&menu=yes', '_blank');
  };

  const handleGitHubClick = () => {
    window.open('https://github.com/yourusername', '_blank');
  };

  return (
    <Footer className="cute-footer">
      <div className="footer-container">
        {/* 主要版权信息 */}
        <div className="footer-main">
          <div className="copyright-section">
            <div className="copyright-text">
              © {currentYear} 我的博客. All Rights Reserved
            </div>
            
            {/* 图标区域 */}
            <div className="icon-section">
              <Space size="large" className="footer-icons">
                <Tooltip title="联系客服" color="pink">
                  <div className="icon-wrapper" onClick={handleServiceClick}>
                    <div className="icon-circle">
                      <CustomerServiceOutlined className="footer-icon" />
                    </div>
                    <div className="icon-label">客服</div>
                  </div>
                </Tooltip>
                
                <Tooltip title="留言反馈" color="cyan">
                  <div className="icon-wrapper" onClick={handleCommentClick}>
                    <div className="icon-circle">
                      <MessageOutlined className="footer-icon" />
                    </div>
                    <div className="icon-label">留言</div>
                  </div>
                </Tooltip>
                
                <Tooltip title="QQ联系" color="blue">
                  <div className="icon-wrapper" onClick={handleQQClick}>
                    <div className="icon-circle">
                      <QqOutlined className="footer-icon" />
                    </div>
                    <div className="icon-label">QQ</div>
                  </div>
                </Tooltip>
              </Space>
            </div>
            
            {/* 技术支持信息 */}
            <div className="tech-section">
              <div className="tech-content">
                <span className="tech-text">Proudly powered by</span>
                <Space size="small" className="tech-stack">
                  <HeartOutlined className="heart-icon" />
                  <span className="tech-item">React</span>
                  <span className="tech-separator">&</span>
                  <span className="tech-item">Ant Design</span>
                </Space>
              </div>
            </div>
          </div>
        </div>
        
        {/* 底部链接 */}
        <div className="footer-links">
          <Divider className="footer-divider" />
          <Row justify="center" gutter={[24, 12]}>
            <Col>
              <a href="/privacy" className="footer-link">隐私政策</a>
            </Col>
            <Col>
              <a href="/terms" className="footer-link">使用条款</a>
            </Col>
            <Col>
              <a href="/about" className="footer-link">关于我们</a>
            </Col>
            <Col>
              <a href="/sitemap" className="footer-link">网站地图</a>
            </Col>
            <Col>
              <a 
                href="https://github.com/yourusername" 
                className="footer-link github-link"
                onClick={handleGitHubClick}
              >
                <GithubOutlined /> GitHub
              </a>
            </Col>
          </Row>
        </div>
      </div>
    </Footer>
  );
};

export default FooterItem;